export { fromEvent } from './file-selector';